export enum QuestionareMethodEnum {
  hasConnected = 'hasConnected',
  hasPassedXTimes = 'hasPassedXTimes',
  hasResponded = 'hasResponded'
}
